import { BaseModalContent } from '../base-modal'
import type { ModalSheetContentProps } from './types'

const ModalSheetContent = ({ ...props }: ModalSheetContentProps) => {
  return <BaseModalContent {...props} />
}
export default ModalSheetContent
